import { FC } from 'react'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { memberAuthGuard } from 'guards/globalGuards'
import { memberDataSelector } from 'selectors/globalSelectors'
import { NavigationRedirect } from 'components/atoms/navigation/NavigationRedirect'
import { getRedirectAnchor } from 'helpers/pageHelpers'
import { withRouter, Redirect } from 'react-router-dom'
import { getUnauthorizedRedirectUrl, makeUrlRelative } from 'helpers/utilsHelpers'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import useRouter from 'hooks/useRouter'
import { PremiumPageRedirect } from 'components/features/pfm/PremiumPageRedirect/PremiumPageRedirect'


const EMPTY_OWN_PROPS = {}

type InternalPageGuardProps = {

}

const InternalPageRedirectComponent: FC<InternalPageGuardProps> = (props) => {
  const { children } = props

  const isMemberLoaded = useSimpleGuard(memberAuthGuard, EMPTY_OWN_PROPS, 'OptionalAuthGuard')

  const { location } = useRouter()
  const url = makeUrlRelative(location)
  const memberData = useStoreSelector(memberDataSelector)
  const isAuthenticated = memberData ? memberData.isAuthenticated : null
  const member = memberData ? memberData.info : null

  if (isAuthenticated === false) {
    return (
      <Redirect to={ getUnauthorizedRedirectUrl() } />
    )
  }

  if (!member || !memberData || !isMemberLoaded) {
    return null
  }

  const redirectAnchor = getRedirectAnchor({
    url,
    allowedStep: member.onboarding_step,
    previousStep: memberData.previousStep,
    isAuthenticated: !!isAuthenticated,
  })

  if (redirectAnchor !== null) {
    const search = location.search || undefined

    return (
      <NavigationRedirect
        to={ redirectAnchor }
        search={ search }
        push
      />
    )
  }

  return (
    <PremiumPageRedirect>
      { children }
    </PremiumPageRedirect>
  )
}

export const InternalPageRedirect = withRouter(InternalPageRedirectComponent)
